function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "icons/social/facebook");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "icons/social/facebook",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M12,0 C5.38330435,0 0,5.38278261 0,12 C0,18.6172174 5.38330435,24 12,24 C18.6172174,24 24,18.6172174 24,12 C24,5.38278261 18.6172174,0 12,0 Z M15.6521739,7.30434783 L13.9356522,7.30434783 C12.9245217,7.30434783 12.5217391,7.54173913 12.5217391,8.2466087 L12.5217391,9.91304348 L15.6521739,9.91304348 L15.1304348,12.5217391 L12.5217391,12.5217391 L12.5217391,19.3043478 L9.39130435,19.3043478 L9.39130435,12.5217391 L7.82608696,12.5217391 L7.82608696,9.91304348 L9.39130435,9.91304348 L9.39130435,8.46573913 C9.39130435,6.2613913 10.2709565,4.69565217 12.8248696,4.69565217 C14.1928696,4.69565217 15.6521739,5.2173913 15.6521739,5.2173913 L15.6521739,7.30434783 Z",
  id: "Shape",
  fill: "#FD8C8C"
}));

var SvgFacebook = function SvgFacebook(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgFacebook, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/facebook.06be8c4c.svg";
export { ForwardRef as ReactComponent };